// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"82ff008d","239":"fe57e927","455":"c317f44e"}[chunkId] + ".chunk.js";
};